import { useQuery } from '@tanstack/react-query';

import { getLastOfflineEventForRoom } from '../data-access/getLastOfflineEventForRoom';

export const useLastOfflineEventForRoom = (roomId: string) =>
  useQuery({
    queryKey: ['room', roomId, 'lastOfflineEvent'],
    queryFn: async () => getLastOfflineEventForRoom(roomId),
  });
